import { SPACE } from '../../AppConstants';
import { GetSpeakerName } from '../../frontend/common/actions/TranscribingActions';
import { ITranscriptionManager, ITranscription, ITranscriptionSegment } from './ITranscriptionManager';
import { ITranscriptionSourceFile } from './ITranscriptionSourceFileProvider';

export interface AddToDocumentOptions {
  withTimestamps: boolean;
  withSpeakers: boolean
}

export interface IAddTranscriptionToCanvas {
  /**
    * GetTranscription will fetch the ITranscription instance at provided storageIndex,
    * if storageIndex is not provided, first entry will be fetched.
    * @method AddTranscriptionToDocument
    * @param {transcription} ITranscription refers to the content to be added.
    * @param {sourceFile} ITranscriptionSourceFile information related to the audio source file info
    * @param {addOption} AddToDocumentOptions refers to the option which user opted to add the content
    * @param {callback} Function (Optional) Function to be called, when add to document operation is finished.
    * @return {void}
    */
  AddTranscriptionToDocument(transcription: ITranscription, sourceFile: ITranscriptionSourceFile | null, addOption: AddToDocumentOptions, callback?: Function) : void;
  AddTranscriptionSegmentToDocument(transcriptionManager: ITranscriptionManager, segmentIndex: number) : void;
}

/** Keeping it as a common util method. Intent of this method is to get 
 * merged speaker transcription to show merged same speaker text while exporting to canvas.
*/
export function GetMergedSpeakerTranscription(transcription: ITranscription): ITranscription {
  let segments: ITranscriptionSegment[] = [];
  let isCurrentSpeakerNameSameAsPrevious: boolean = false;
  let currentSpeakerName: string = "";
  let previousSpeakerName: string = "";
  for (let index = 0; index < transcription.transcriptSegments.length; index++) {
    if (index > 0) {
      previousSpeakerName = GetSpeakerName(transcription.transcriptSegments[index-1].speakerId, transcription.speakerNames);
      currentSpeakerName = GetSpeakerName(transcription.transcriptSegments[index].speakerId, transcription.speakerNames);
      isCurrentSpeakerNameSameAsPrevious = previousSpeakerName == currentSpeakerName;
    }
    if (isCurrentSpeakerNameSameAsPrevious) {
      segments[segments.length-1].text += SPACE + transcription.transcriptSegments[index].text;
      segments[segments.length-1].end = transcription.transcriptSegments[index].end;
    } else {
      //Note: creating a copy of segment on the fly othewise it will impact original segments using reference.
      segments.push(Object.assign({}, transcription.transcriptSegments[index]));
    }
  }

  return {
    transcriptSegments: segments,
    speakerNames: transcription.speakerNames
  }
}